import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * @param {number} intervalMs
 * @param {"auto"|"trabajador"|"admin"} scope — "trabajador" en la app del operario; "admin" en el panel de gestión
 */
export function useNotificaciones(intervalMs = 30000, scope = "auto") {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [data, setData] = useState({ total: 0, total_pendientes: 0, items: [] });
  const prevTotal = useRef(0);

  const modoAdmin =
    scope === "admin" ||
    (scope === "auto" && user?.rol !== "worker" && (pathname.startsWith("/admin") || pathname.startsWith("/superadmin")));

  const cargar = useCallback(async () => {
    if (!user) return;
    try {
      if (modoAdmin) {
        const { data: sol } = await api.get("/solicitudes/notificaciones");
        const items = sol.items || [];
        const total = sol.total || 0;
        if (total > prevTotal.current && prevTotal.current > 0) {
          toast.info(items[0]?.titulo || "Tienes nuevos avisos pendientes");
        }
        prevTotal.current = total;
        setData({ total, total_pendientes: total, items });
        return;
      }
      const { data: res } = await api.get("/notificaciones");
      const items = res.items || [];
      const total = res.total_pendientes ?? res.total ?? 0;
      if (total > prevTotal.current && prevTotal.current > 0) {
        toast.info(items[0]?.titulo || "Tienes nuevos avisos");
      }
      prevTotal.current = total;
      setData({ total, total_pendientes: total, items });
    } catch {
      /* ignorar si no autenticado */
    }
  }, [user, modoAdmin]);

  useEffect(() => {
    cargar();
    const t = setInterval(cargar, intervalMs);
    const onRefresh = () => cargar();
    window.addEventListener("notificaciones-actualizar", onRefresh);
    return () => {
      clearInterval(t);
      window.removeEventListener("notificaciones-actualizar", onRefresh);
    };
  }, [cargar, intervalMs]);

  return { ...data, recargar: cargar };
}
